import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxArrowOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.4 1c-.554 0-1.055.018-1.48.099-.434.081-.875.242-1.227.594S.18 2.486.1 2.92C.019 3.345 0 3.846 0 4.4s.018 1.055.099 1.48c.081.434.242.875.594 1.227s.793.513 1.227.594c.425.08.926.099 1.48.099h16.8l-.002 8.174c-.036 2.496-.51 3.61-1.115 4.185-.622.592-1.822 1.038-4.416 1.038H13v1.8h1.667c5.386 0 7.256-1.759 7.33-6.997H22V7.716c.47-.079.933-.236 1.307-.61.352-.351.513-.792.594-1.226.08-.425.099-.926.099-1.48s-.018-1.055-.099-1.48c-.081-.434-.242-.875-.594-1.227s-.793-.513-1.227-.594C21.655 1.019 21.154 1 20.6 1zm17.2 5c.54 0 .898-.02 1.147-.067.25-.048.337-.129.386-.386.046-.249.067-.607.067-1.147s-.02-.898-.067-1.147c-.048-.25-.129-.337-.386-.386-.249-.046-.607-.067-1.147-.067H3.4c-.54 0-.898.02-1.147.067-.257.049-.338.136-.386.386-.046.249-.067.607-.067 1.147s.02.898.067 1.147c.048.25.129.337.386.386C2.502 5.979 2.86 6 3.4 6zM12 18.05c0-2.414-1.78-4.95-4.6-4.95H5.443l2.1-2.1L6.27 9.727 1.997 14l4.273 4.273L7.543 17l-2.1-2.1H7.4c1.58 0 2.8 1.464 2.8 3.15S8.98 21.2 7.4 21.2H3V23h4.4c2.82 0 4.6-2.535 4.6-4.95"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArchiveboxArrowOutlinedSize24Glyph.displayName = 'ArchiveboxArrowOutlinedSize24Glyph';
